import callAPI from "config/callAPI";
import PortalAuth from "config/auth/PortalAuth";
import { setPortalActiveMenu } from "libraries/common_functions";

import React from "react";
import copy from "copy-to-clipboard";

import PortalHeader from "pages/portal/includes/PortalHeader";
import PortalMobileMenu from "pages/portal/includes/PortalMobileMenu";
import PortalTopMenu from "pages/portal/includes/PortalTopMenu";
import PortalFooter from "pages/portal/includes/PortalFooter";

const ENDPOINT = process.env.REACT_APP_BACKEND_URL + '/track_url';

class PortalUrlDetails extends React.Component {  
    constructor(){
        super();
        this.state = {
            isloggedin: false,
            alertColor: '',
            rstatus: '',
            rmessage: '',
            rdata: []
        } 

        let isloggedinPromise = PortalAuth();
        
        isloggedinPromise.then((isloggedin) => {
            this.setState({isloggedin: isloggedin});
        });

        this.getURLDetails();
    }

    componentDidMount(){
        setPortalActiveMenu('short_url');
    }

    async getURLDetails(){
        const location = window.location;
        const queryParams = new URLSearchParams(location.search);

        var url_id = queryParams.get('id');
        var data = {url_id: url_id};

        const {rstatus, rmessage, rdata } = await callAPI(ENDPOINT, data);
        this.setState({
            rstatus: rstatus,
            rmessage: rmessage,
            rdata: rdata
        });

        if (rstatus === true){ 
            this.setState({alertColor: 'green'}); 
        } 
        else if (rstatus === false) { 
            this.setState({alertColor: 'red'}); 
        }
    }

    render() {
        if (!this.state.isloggedin){
            return (<></>);
        }

        return (
            <>
                <PortalMobileMenu />

                <div className="flex">
                    
                    <PortalHeader />
                        
                    <div className="content">
                            
                        <PortalTopMenu page_name="URL Details" />

                        <div className="intro-y flex items-center mt-8">
                            <h2 className="text-lg font-medium ">
                                URL Details ({ this.state.rstatus === true ? 
                                                        
                                                    <span style={{color: 'blue', display: 'inline-block'}}> {this.state.rdata.shortened_url} <span style={{color: 'black', cursor: 'pointer', display: 'inline-block'}} onClick={() => copy(this.state.rdata.shortened_url)}><i data-feather="copy" className="mx-auto" style={{display: 'inline-block'}}></i></span></span> 
                                                    
                                                : 
                                                
                                                    " -- " 
                                              } 
                                            )
                            </h2>
                        </div>

                        <div className="grid grid-cols-12 gap-6 mt-5">
                            <div className="intro-y col-span-12 lg:col-span-12">
                                <div className="intro-y box mt-5">

                                    { this.state.rstatus === true ?

                                        <div className="p-5" id="horizontal-form">
                                            <div className="preview">
                                                <div className="flex flex-col sm:flex-row items-center">
                                                    <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                        <label className="w-1/2 sm:w-20 sm:text-right mr-3">Campaign Name :</label>
                                                        <label className="w-1/2 mt-2 flex-1" style={{color: 'grey'}}>{this.state.rdata.campaign_name}</label>
                                                    </div>
                                                    <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                        <label className="w-1/2 sm:w-20 sm:text-right mr-3">UTM Source :</label>
                                                        <label className="w-1/2 mt-2 flex-1" style={{color: 'grey'}}>{this.state.rdata.utm_source}</label>
                                                    </div>
                                                </div>
                                                <div className="flex flex-col sm:flex-row items-center mt-3">
                                                    <div className="w-full ml-5 pb-5" style={{overflowX: "auto", overflowY: "hidden"}}>
                                                        <label className="w-1/4 sm:w-20 sm:text-right mr-3">Destination URL :</label>
                                                        <a href={this.state.rdata.url} target="_blank" rel="noreferrer" className="w-3/4 mt-2 flex-1 ml-1" style={{color: 'blue'}}>{this.state.rdata.url}</a>
                                                    </div>
                                                </div>
                                                <hr className="border mt-5 mb-3"></hr>
                                                <div className="flex flex-col sm:flex-row items-center">
                                                    <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                        <label className="w-1/2 sm:w-20 sm:text-right mr-3">Total Clicks:</label>
                                                        <label className="w-1/2 mt-2 flex-1" style={{color: this.state.alertColor, fontSize: "3rem"}}>{this.state.rdata.link_clicked}</label>
                                                    </div>
                                                    <div className="w-full xl:w-1/2 md:w-1/2 sm:w-1/2 ml-5 mt-3">
                                                        <h3 className="w-full sm:mr-5" style={{fontSize: "1rem"}}>Link Clicked by Location</h3>
                                                        <hr className="border mt-2 mb-2"></hr>
                                                        
                                                        { this.state.rdata.link_clicked_by_location.length > 0 ?

                                                            this.state.rdata.link_clicked_by_location.map(function(clicks_by_location, i){

                                                                return (
                                                                    <React.Fragment key={`${i+1}`}>
                                                                        <div className="w-full mt-3">
                                                                            <label className="w-1/2 sm:text-left" style={{display: "inline-block"}}>{clicks_by_location.location}</label>
                                                                            <label className="w-1/2 sm:text-left" style={{display: "inline-block", color: "green"}}>{clicks_by_location.link_clicked}</label>
                                                                        </div>
                                                                    </React.Fragment>
                                                                )

                                                            })

                                                            :

                                                            <p style={{ color: "red", paddingTop: 2}}>
                                                                There is no data to show!
                                                            </p>

                                                            }
                                                    
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    
                                    :

                                        <p style={{ color: this.state.alertColor, padding: "10px"}}>
                                            {this.state.rmessage}
                                        </p>

                                    }

                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>

                <PortalFooter />
            </>
        );
    }
}

export default PortalUrlDetails;
